<!--<table cTable>-->
<!--    <tbody>-->
<!--        <tr *ngFor="let item of result | keyvalue: originalOrder" class="hover:bg-gray-300">-->
<!--            <td class="font-semibold">{{ item.key }}</td>-->
<!--            <td>{{ item.value }}</td>-->
<!--        </tr>-->
<!--    </tbody>-->
<!--</table>-->
<div class="flex flex-col space-y-4">
    <div *ngFor="let field_group of result | keyvalue: originalOrder" class="flex flex-col gap-y-4">
        <div class="w-full bg-blue-100 font-semibold px-4 py-3 rounded text-gray-900 text-sm ">
            {{ field_group.key }}
        </div>
        <div cListGroup>
            <div *ngFor="let field of field_group.value | keyvalue : originalOrder" cListGroupItem>
                <div class="flex justify-between w-full">
                    <span class="font-semibold">{{ field.value['verbose_name'] }}</span>
                    <span class="text-gray-500 w-2/3" [innerHTML]="field.value['value']"></span>
                </div>
            </div>
        </div>
    </div>
    <div class="flex justify-center mb-4">
        <a cButton color="primary" [href]="feedbackURL" target="_blank">
            {{ language === 'vi' ? "Xem chi tiết và góp ý" : "See detail and feedback"}}
        </a>
    </div>
</div>